module.exports = __webpack_public_path__ + "static/media/collision_circle.fragment.6f61a8a3.glsl";